import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=1aa06bb6&scoped=true&"
import script from "./ProjectList.vue?vue&type=script&lang=ts&"
export * from "./ProjectList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=1aa06bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa06bb6",
  null
  
)

export default component.exports